// extracted by mini-css-extract-plugin
export default {"container":"confirm-modal_container__MXbh7","title":"confirm-modal_title__x0+Dy","content":"confirm-modal_content__RZ5jn"};